import React, { CSSProperties, createContext, useReducer } from 'react';

import { renderToString } from 'react-dom/server';

import ComponentType from '../../types/Component';
import Translation from '../../types/Translation';
import { LanguagesEnum, PlaceLanguagesType } from '../../types/languages';
import { isNull, isString, isUndefined } from '../../utils/typeCheck';

import localeProviderReducer from './reducer';
import { LocaleProviderDispatcher } from './types';

let i18nMessages: Translation | null | undefined = null;
let languageCode: LanguagesEnum | null = null;
const REGEXP = /\{([^{}]+)}/g;

const getValueBack = (key: string, values?: { [key: string]: string | JSX.Element }) => {
	if (!values) return key;

	return values?.[key] ?? '';
};

function i18n(
	id: keyof Translation,
	values?: { [key: string]: string | JSX.Element },
	isHtml?: boolean,
	embedConfig?: {
		isBold?: boolean;
		isSpan?: boolean;
		style?: CSSProperties;
	}
): string; // TS trick to not show error that JSX.Element is not allowed, only string

function i18n(
	id: keyof Translation,
	values?: { [key: string]: string | JSX.Element },
	isHtml?: boolean,
	embedConfig?: {
		isBold?: boolean;
		isSpan?: boolean;
		style?: CSSProperties;
	}
): string | JSX.Element {
	let result = i18nMessages?.[id] || '';

	if (!result) {
		// console.warn(`>>> I18N translation not found (${id}). Language: ${languageCode}`);
	}

	if (values || !!embedConfig) {
		result = result.replace(REGEXP, (match, key): any => {
			if (embedConfig?.isBold) {
				return renderToString(<b style={embedConfig.style}>{getValueBack(key, values)}</b>);
			}
			if (embedConfig?.isSpan) {
				return renderToString(<span style={embedConfig.style}>{getValueBack(key, values)}</span>);
			}

			if (isUndefined(values?.[key]) || isNull(values?.[key])) {
				return '';
			}

			return isString(values?.[key]) ? values?.[key] : renderToString(values?.[key] as JSX.Element);
		});
	}

	if (isHtml) {
		return <pre dangerouslySetInnerHTML={{ __html: result }} />;
	}

	return result;
}

export const LocaleProviderContext = createContext({
	state: {} as PlaceLanguagesType,
	dispatch: {} as LocaleProviderDispatcher,
});

export const LocaleProvider: ComponentType<{
	language: LanguagesEnum;
	initialState: PlaceLanguagesType;
}> = (props) => {
	const { children, initialState } = props;
	const [state, dispatch] = useReducer(localeProviderReducer, initialState);
	const { content } = state;
	i18nMessages = content;
	languageCode = props.language;

	return (
		<LocaleProviderContext.Provider value={{ state, dispatch }}>
			{children}
		</LocaleProviderContext.Provider>
	);
};

export default i18n;
